import * as tslib_1 from "tslib";
import { makeGetRequest } from 'owa-ows-gateway';
var GET_BRANDSSUBSCRIPTION_URL = 'ows/api/beta/subscriptions';
function getUserBrandsSubscriptionsService() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, makeGetRequest(GET_BRANDSSUBSCRIPTION_URL)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export default getUserBrandsSubscriptionsService;
//# sourceMappingURL=getBrandsSubscriptionsService.js.map